import { Progress, ProgressProps } from "@chakra-ui/react";
import React from "react";

export const StatProgress: React.FC<ProgressProps> = React.forwardRef<
  HTMLAnchorElement,
  ProgressProps
>(({ ...props }, ref) => (
  <Progress
    size="xs"
    colorScheme="lightGreen"
    maxWidth="140px"
    my="4px"
    ref={ref}
    {...props}
  />
));

StatProgress.displayName = "StatProgress";
